import { Injectable } from '@angular/core';
import { ACTIONS_CONFIG } from '@config/actions.config';
import { LANGUAGE_CONFIG } from '@config/language.config';
import { TYPE_ACCORDION_CONFIG, TYPE_PRIMARY_CONFIG, TYPE_SECOND_CONFIG, TYPE_SINGLE_CONFIG } from '@config/menu.config';
import { SERVICES_CONFIG } from '@config/services.config';
import { environment } from '@environments/environment';

@Injectable()
export class AppConfig {
  readonly URL: string = environment.apiUrl;
  readonly LANG = LANGUAGE_CONFIG;
  readonly ACTIONS = ACTIONS_CONFIG;
  readonly INACTIVE_TIME: number = environment.inactiveTime;
  readonly ALERT_INACTIVE_TIME: number = environment.alertInactiveTime;
  readonly MIN_DATE: any = { value: 2, time: 'years' };
  readonly DATE_FORMAT: string = 'YYYY-MM-DD HH:mm:ss.SSS Z';
  readonly DATE_FORMAT_SEARCH: string = 'YYYY-MM-DD HH:mm:ss.SSS';
  readonly DATE_FORMAT_LIST: string = 'dd/MM/yyyy';
  readonly DATE_FORMAT_LABEL: string = 'DD/MM/YYYY';
  readonly DATE_FORMAT_DETAIL: string = 'YYYY-MM-DD';
  readonly HOUR_FORMAT: string = 'HH:mm:ss.SSS';
  readonly TYPE_SINGLE = TYPE_SINGLE_CONFIG;
  readonly TYPE_ACCORDION = TYPE_ACCORDION_CONFIG;
  readonly TYPE_PRIMARY = TYPE_PRIMARY_CONFIG;
  readonly TYPE_SECOND = TYPE_SECOND_CONFIG;
  readonly OWNER: string = 'G';
  readonly BENEFICIARY: string = 'B';
  readonly EDIT_OPTIONS = {cell: 1, identify: 2};
  readonly CHANNEL: string = 'ADM';
  readonly SERVICES = SERVICES_CONFIG;
  readonly NOTIFICATION = {
    alert: 'alert',
    error: 'error',
    fatalError: 'fatal-error',
    info: 'info',
    success: 'success'
  };
}
